/* eslint-disable */
import * as SchemaTypes from '../../api/graphql/core/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContextFragment = { __typename?: 'Context', id: any, baseProfileId: any, name?: string | null, role?: string | null, type?: SchemaTypes.Context_Type_Enum | null, dateFrom?: any | null, dateTo?: any | null, dateScale: SchemaTypes.Context_Datescale_Enum, companyProfileId?: any | null, educationalOrganisationId?: any | null, educationalCourseId?: any | null, educationalCourseName?: string | null, summary?: Array<string | null> | null, createdAt: any, updatedAt: any, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string } | null } | null };

export type MediaFragment = { __typename?: 'Media', id: any, type: SchemaTypes.Media_Type_Enum, URI: string, mediaVariantCollection?: { __typename?: 'MediaVariantConnection', edges: Array<{ __typename?: 'MediaVariantEdge', node: { __typename?: 'MediaVariant', id: any, type: SchemaTypes.MediaVariant_Type_Enum, URI: string, width?: number | null, height?: number | null } }> } | null };

export type FetchContextQueryVariables = SchemaTypes.Exact<{
  filter: SchemaTypes.ContextFilter;
  includeStories: SchemaTypes.Scalars['Boolean'];
}>;


export type FetchContextQuery = { __typename?: 'Query', collection?: { __typename?: 'ContextConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ __typename?: 'ContextEdge', node: { __typename?: 'Context', id: any, baseProfileId: any, name?: string | null, role?: string | null, type?: SchemaTypes.Context_Type_Enum | null, dateFrom?: any | null, dateTo?: any | null, dateScale: SchemaTypes.Context_Datescale_Enum, companyProfileId?: any | null, educationalOrganisationId?: any | null, educationalCourseId?: any | null, educationalCourseName?: string | null, summary?: Array<string | null> | null, createdAt: any, updatedAt: any, storyContextCollection?: { __typename?: 'StoryContextConnection', edges: Array<{ __typename?: 'StoryContextEdge', node: { __typename?: 'StoryContext', id: any, contextId: any, storyId: any, story?: { __typename?: 'Story', id: any, profileId?: any | null, companyProfileId?: any | null, type: SchemaTypes.Story_Type_Enum, rateAverage?: number | null, rateCount: number, mediaSet?: { __typename?: 'MediaSet', id: any, mediaCollection?: { __typename?: 'MediaConnection', edges: Array<{ __typename?: 'MediaEdge', node: { __typename?: 'Media', id: any, type: SchemaTypes.Media_Type_Enum, URI: string, mediaVariantCollection?: { __typename?: 'MediaVariantConnection', edges: Array<{ __typename?: 'MediaVariantEdge', node: { __typename?: 'MediaVariant', id: any, type: SchemaTypes.MediaVariant_Type_Enum, URI: string, width?: number | null, height?: number | null } }> } | null } }> } | null } | null, storySkillCollection?: { __typename?: 'StorySkillConnection', edges: Array<{ __typename?: 'StorySkillEdge', node: { __typename?: 'StorySkill', rateAverage?: number | null, rateCount: number, skill?: { __typename?: 'Skill', id: number, name: string } | null } }> } | null } | null } }> } | null, companyProfile?: { __typename?: 'CompanyProfile', id: any, name: string, logo?: { __typename?: 'Media', id: any, URI: string } | null } | null } }> } | null };

export const ContextFragmentDoc = gql`
    fragment Context on Context {
  id
  baseProfileId
  name
  role
  type
  dateFrom
  dateTo
  dateScale
  companyProfileId
  educationalOrganisationId
  educationalCourseId
  educationalCourseName
  summary
  createdAt
  updatedAt
  companyProfile {
    id
    name
    logo {
      id
      URI
    }
  }
}
    `;
export const MediaFragmentDoc = gql`
    fragment Media on Media {
  id
  type
  URI
  mediaVariantCollection {
    edges {
      node {
        id
        type
        URI
        width
        height
      }
    }
  }
}
    `;
export const FetchContextDocument = gql`
    query FetchContext($filter: ContextFilter!, $includeStories: Boolean!) {
  collection: contextCollection(filter: $filter) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      node {
        ...Context
        storyContextCollection {
          edges {
            node {
              id
              contextId
              storyId
              story @include(if: $includeStories) {
                id
                profileId
                companyProfileId
                type
                rateAverage
                rateCount
                mediaSet {
                  id
                  mediaCollection {
                    edges {
                      node {
                        ...Media
                      }
                    }
                  }
                }
                storySkillCollection {
                  edges {
                    node {
                      rateAverage
                      rateCount
                      skill {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ContextFragmentDoc}
${MediaFragmentDoc}`;
export function useFetchContextQuery(baseOptions: Apollo.QueryHookOptions<FetchContextQuery, FetchContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchContextQuery, FetchContextQueryVariables>(FetchContextDocument, options);
      }
export function useFetchContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchContextQuery, FetchContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchContextQuery, FetchContextQueryVariables>(FetchContextDocument, options);
        }
export type FetchContextQueryHookResult = ReturnType<typeof useFetchContextQuery>;
export type FetchContextLazyQueryHookResult = ReturnType<typeof useFetchContextLazyQuery>;
export type FetchContextQueryResult = Apollo.QueryResult<FetchContextQuery, FetchContextQueryVariables>;